/**
 * Controller metadata used to store information about registered controller.
 */
export interface ControllerMetadataArgs {

    /**
     * Controller class.
     */
    target: Function;
    
}